import { Injectable } from '@angular/core';
import { SessionManagerService } from '../services/session-manager.service';

@Injectable({
  providedIn: 'root'
})
export class AppBootstrapService {
  constructor(private readonly sessionManager: SessionManagerService) {
    // El constructor se ejecuta automáticamente cuando se inyecta el servicio
  }

  initialize(): void {
    void this.sessionManager;
  }
}